<template>
  <s-btn v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <s-tooltip
      v-if="tip && this.$attrs.readonly"
      class="icon"
      :transfer="true"
      :content="tip"
      placement="bottom"
    >
      &nbsp;
      <s-icon icon="question"></s-icon>
    </s-tooltip>
    <s-icon class="icon-right" :icon="loading ? 'loading' : ''"></s-icon>
  </s-btn>
</template>

<script>
export default {
  name: 'common-btn',
  props: {
    text: String,
    tip: String,
    loading: Boolean,
  },
}
</script>
